module.exports = __webpack_public_path__ + "files/edebf80e2b74974ec6a61c771a17ba93.png";